import { changeMainProdFeature } from '@pages/VirtualChangeOfDestinationNumber/services';
import { getRequestData } from '@/utils';

import cloneDeep from 'lodash/cloneDeep';

const defaultState = {
  step: 0, // 变更呼叫转移号码业务流程的步骤
  searchCustInfo: {}, // 从搜索页面同步过来的用户信息
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
};
export default {
  namespace: 'virtualChangeOfDestinationNumber',
  state: cloneDeep(defaultState),
  effects: {
    // 变更固话群组
    *changeMainProdFeature({ payload }, { call }) {
      const response = yield call(changeMainProdFeature, payload);
      return getRequestData(response, false);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
